// IMPORT REACT
import React from 'react';
import Axios from 'axios';

// IMPORT COMPONENTS
import YAText from '../../Text';
import YARow from '../../Grid/Row';
import YAColumn from '../../Grid/Column';
import YAButton from '../../Form/Button';
import YASubmit from '../../Form/Submit';
import YAIcon from '../../Icon';
import YAInput from '../../Form/Input';
import YAAlert from '../../Alert';

// IMPORT STYLES
import { SC_Resource, SC_IconContainer } from '../styles';


class YAResource extends React.Component {

	constructor(props) {
		super();
		this.state = {
			formError: null,
			formSuccess: null,
			allPermissions: [],
			allCategories: [],
		};
	}

	componentDidMount() {

		this.getCategories('en').then(data => {
			this.setState({
				allCategories: data,
			});
		});

	}

	editFile(e, remove) {
		e.preventDefault();
		let url = '/wp-json/wp/v2/weemarkable/file-manage/';
		let form = document.getElementById("edit_file_form");
		let data = new FormData(form);
		data.append('file_id', this.props.file.ID);
		if (remove) {
			data.append('delete', this.props.file.ID);
		}
		return Axios({
			method: 'post',
			url: url,
			data: data,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	getCategories(lang) {
		let url = '/wp-json/wp/v2/weemarkable/categories/';
		url += '?lang=';
		url += lang;
		url += '&parent=any';
		return Axios({
			method: 'get',
			url: url,
			headers: {
				// eslint-disable-next-line no-undef
				'X-WP-Nonce': frontend_ajax_object.nonce
			},
		}).then((response) => {
			return response.data;
		}).catch(function (error) {
			console.log(error, 'Error');
		});
	}

	render() {
		const file = this.props.file;
		const id = file && file.ID;
		const fileName = file ? file.filename : "Sorry, no files found.";
		const fileSize = file && file.filesize;
		const mimeType = file && file.post_mime_type;
		const link = file && file.guid;
		const postDate = file && file.post_date;

		let formError = this.state.formError;
		let allCategories = this.state.allCategories;
		let allPermissions = this.state.allPermissions;
		let cancelCallbackFunction = this.props.cancelCallbackFunction;
		let selectedCategory = this.props.selectedCategory;
		let startEditingCallbackFunction = this.props.startEditingCallbackFunction;
		let isWeemarkableSuperAdmin = this.props.isWeemarkableSuperAdmin;

		let editing = this.props.editing;

		let categoriesOptions = allCategories && allCategories.length ? allCategories.map((category) => {
			return ({
				id: category.slug,
				label: category.ancestors + ' ' + category.name_english,
				value: category.term_id,
			});
		}) : null;

		return (
			<SC_Resource>
				<YARow center="vertical">
					<YAColumn size="col-auto" autoWidth>
						<SC_IconContainer>
							<YAIcon icon="file" height="100px" fill="gray200" altFill="gray400" />
						</SC_IconContainer>
					</YAColumn>
					<YAColumn autoWidth>
						{link ?
							<YAButton color="link" bootstrap="text-left text-break" href={link}>
								{fileName + '.' + mimeType.ext + '<br/><span class="text-muted small">Added ' + postDate + '</span>'}
							</YAButton> : <YAText bootstrap="font-weight-bold">
								{fileName}
							</YAText>}
					</YAColumn>
					<YAColumn size="col-auto" autoWidth>
						<YAText>
							{fileSize}
						</YAText>
					</YAColumn>
					{link ?
						<YAColumn size="col-auto" autoWidth>
							{isWeemarkableSuperAdmin && (editing && editing == id) &&
								<YAButton size="sm" color="dark" onClick={() => { cancelCallbackFunction() }}>
									Cancel
						</YAButton>
							}
							{isWeemarkableSuperAdmin && (!editing || editing != id) &&
								<YAButton size="sm" color="dark" onClick={() => { startEditingCallbackFunction(id) }}>
									Edit
						</YAButton>
							}
							{(!editing || editing != id) &&
								<YAButton size="sm" color="outline-dark" href={link}>
									Open
						</YAButton>
							}
						</YAColumn> : null}
				</YARow>

				{isWeemarkableSuperAdmin && (editing && editing == id) &&
					<form id="edit_file_form" onSubmit={(e) => {
						this.editFile(e).then(data => {
							if (data.error) {
								this.setState({
									formSuccess: null,
									formError: data.error
								})
							} else if (data.success) {
								this.setState({
									formError: null
								})
								cancelCallbackFunction(data.success)
							}
						});
					}}>
						{formError &&
							<YAAlert color="danger">
								{formError}
							</YAAlert>}

						<YAInput type="select" id="edit_parent" label="Parent Folder" value={selectedCategory} options={categoriesOptions} />

						<YAButton color="danger" onClick={(e) => {
							e.preventDefault();
							var confirmDelete = window.confirm("Are you sure you want to delete this file?");
							if (confirmDelete == true) {
								this.editFile(e, true).then(data => {
									if (data.error) {
										this.setState({
											formSuccess: null,
											formError: data.error
										})
									} else if (data.success) {
										this.setState({
											formError: null
										})
										cancelCallbackFunction(data.success)
									}
								});
							}
						}}>
							Delete
					</YAButton>
						<YASubmit color="success" value="Save" />

						<br />	<br />
					</form>
				}
			</SC_Resource>
		)
	}
}
export default YAResource;